import { RootState } from 'store/index';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { RequestContactState, ResourceListSelectors } from 'typings/state';

const selectors: ResourceListSelectors = createResourceListSelectors(
    (state: RootState): RequestContactState => state.requestContact,
);

export default selectors;
